import React from "react";

interface FormsAddUniteProps {
  selectedtype: string;
  register: any;
  errors: any;
  setSelectedSousType: (newvalue: string) => void;
}
const FormsAddUnite = ({
  selectedtype,
  register,
  errors,
  setSelectedSousType,
}: FormsAddUniteProps) => {
  return (
    <>
      {selectedtype == "CLASSE" && (
        <>
          <div className="col-span-6 sm:col-span-6">
            <label
              htmlFor="nom_unite"
              className="block text-md font-bold leading-6 text-gray-900"
            >
              Nom unité *
            </label>
            <input
              type="text"
              name="nom_unite"
              id="nom_unite"
              placeholder="Saisir nom"
              className="  my-3 border border-gray-300 text-gray-900 font-semibold text-md rounded-lg focus:ring-gexpertise-100 focus:border-gexpertise-200 block w-full p-2.5 "
              {...register("nom_unite", {
                required: true,
              })}
            />
            {errors.nom_unite && (
              <span className="bg-red-100 text-red-800 text-md font-medium mr-2 mt-2 px-2.5 py-0.5 rounded ">
                champs obligatoire
              </span>
            )}
          </div>
          <div className="col-span-6 sm:col-span-6">
            <label
              htmlFor="sous_type_unite"
              className="block text-md font-bold leading-6 text-gray-900"
            >
              Sous type d'unité
            </label>

            <select
              name="sous_type_unite"
              id="sous_type_unite"
              className="  my-3 border border-gray-300 text-gray-900 font-semibold text-md rounded-lg focus:ring-gexpertise-100 focus:border-gexpertise-200 block w-full p-2.5 "
              {...register("sous_type_unite")}
              onChange={(e) => {
                setSelectedSousType(e.target.value);
              }}
            >
              <option value={""}>Choisir votre sous type</option>
              <option value={"Logement"}>Logement</option>
              <option value={"Commerce"}>Commerce</option>
              <option value={"Bureau"}>Bureau</option>
              <option value={"Industriel"}>Industriel</option>
              <option value={"Logistique"}>Logistique</option>
              <option value={"Equipements publics"}>Equipements publics</option>
            </select>
          </div>

          <div className="col-span-3 sm:col-span-3">
            <label
              htmlFor="surface_plancher"
              className="block text-md font-bold leading-6 text-gray-900"
            >
              Surface de plancher
            </label>
            <input
              type="text"
              name="surface_plancher"
              id="surface_plancher"
              placeholder="Saisir surface de plancher"
              className="  my-3 border border-gray-300 text-gray-900 font-semibold text-md rounded-lg focus:ring-gexpertise-100 focus:border-gexpertise-200 block w-full p-2.5 "
              {...register("surface_plancher")}
            />
          </div>
          <div className="col-span-3 sm:col-span-3">
            <label
              htmlFor="surface_habitable"
              className="block text-md font-bold leading-6 text-gray-900"
            >
              Surface habitable
            </label>
            <input
              type="text"
              name="surface_habitable"
              id="surface_habitable"
              placeholder="Saisir surface habitable"
              className="  my-3 border border-gray-300 text-gray-900 font-semibold text-md rounded-lg focus:ring-gexpertise-100 focus:border-gexpertise-200 block w-full p-2.5 "
              {...register("surface_habitable")}
            />
          </div>
        </>
      )}
      {(selectedtype == "LOCATIVE") && (
        <>
          <div className="col-span-6 sm:col-span-6">
            <label
              htmlFor="nom_unite"
              className="block text-md font-bold leading-6 text-gray-900"
            >
              Nom unité *
            </label>
            <input
              type="text"
              name="nom_unite"
              id="nom_unite"
              placeholder="Saisir nom"
              className="  my-3 border border-gray-300 text-gray-900 font-semibold text-md rounded-lg focus:ring-gexpertise-100 focus:border-gexpertise-200 block w-full p-2.5 "
              {...register("nom_unite", {
                required: true,
              })}
            />
            {errors.nom_unite && (
              <span className="bg-red-100 text-red-800 text-md font-medium mr-2 mt-2 px-2.5 py-0.5 rounded ">
                champs obligatoire
              </span>
            )}
          </div>
          <div className="col-span-3 sm:col-span-3">
            <label
              htmlFor="surface_plancher"
              className="block text-md font-bold leading-6 text-gray-900"
            >
              Surface de plancher
            </label>
            <input
              type="text"
              name="surface_plancher"
              id="surface_plancher"
              placeholder="Saisir surface de plancher"
              className="  my-3 border border-gray-300 text-gray-900 font-semibold text-md rounded-lg focus:ring-gexpertise-100 focus:border-gexpertise-200 block w-full p-2.5 "
              {...register("surface_plancher")}
            />
          </div>
          <div className="col-span-3 sm:col-span-3">
            <label
              htmlFor="surface_habitable"
              className="block text-md font-bold leading-6 text-gray-900"
            >
              Surface habitable
            </label>
            <input
              type="text"
              name="surface_habitable"
              id="surface_habitable"
              placeholder="Saisir surface habitable"
              className="  my-3 border border-gray-300 text-gray-900 font-semibold text-md rounded-lg focus:ring-gexpertise-100 focus:border-gexpertise-200 block w-full p-2.5 "
              {...register("surface_habitable")}
            />
          </div>
        </>
      )}
       {(selectedtype == "COPROPRIETE") && (
        <>
          <div className="col-span-6 sm:col-span-6">
            <label
              htmlFor="nom_unite"
              className="block text-md font-bold leading-6 text-gray-900"
            >
              Nom unité *
            </label>
            <input
              type="text"
              name="nom_unite"
              id="nom_unite"
              placeholder="Saisir nom"
              className="  my-3 border border-gray-300 text-gray-900 font-semibold text-md rounded-lg focus:ring-gexpertise-100 focus:border-gexpertise-200 block w-full p-2.5 "
              {...register("nom_unite", {
                required: true,
              })}
            />
            {errors.nom_unite && (
              <span className="bg-red-100 text-red-800 text-md font-medium mr-2 mt-2 px-2.5 py-0.5 rounded ">
                champs obligatoire
              </span>
            )}
          </div>
          <div className="col-span-6 sm:col-span-6">
            <label
              htmlFor="nom_unite"
              className="block text-md font-bold leading-6 text-gray-900"
            >
              Numéro de lot *
            </label>
            <input
              type="text"
              name="Numéro de lot"
              id="numero_lot"
              placeholder="Saisir Numéro de lot"
              className="  my-3 border border-gray-300 text-gray-900 font-semibold text-md rounded-lg focus:ring-gexpertise-100 focus:border-gexpertise-200 block w-full p-2.5 "
              {...register("numero_lot", {
                required: true,
              })}
            />
            {errors.numero_lot && (
              <span className="bg-red-100 text-red-800 text-md font-medium mr-2 mt-2 px-2.5 py-0.5 rounded ">
                champs obligatoire
              </span>
            )}
          </div>
          <div className="col-span-3 sm:col-span-3">
            <label
              htmlFor="surface_plancher"
              className="block text-md font-bold leading-6 text-gray-900"
            >
              Surface de plancher
            </label>
            <input
              type="text"
              name="surface_plancher"
              id="surface_plancher"
              placeholder="Saisir surface de plancher"
              className="  my-3 border border-gray-300 text-gray-900 font-semibold text-md rounded-lg focus:ring-gexpertise-100 focus:border-gexpertise-200 block w-full p-2.5 "
              {...register("surface_plancher")}
            />
          </div>
          <div className="col-span-3 sm:col-span-3">
            <label
              htmlFor="surface_habitable"
              className="block text-md font-bold leading-6 text-gray-900"
            >
              Surface habitable
            </label>
            <input
              type="text"
              name="surface_habitable"
              id="surface_habitable"
              placeholder="Saisir surface habitable"
              className="  my-3 border border-gray-300 text-gray-900 font-semibold text-md rounded-lg focus:ring-gexpertise-100 focus:border-gexpertise-200 block w-full p-2.5 "
              {...register("surface_habitable")}
            />
          </div>
        </>
      )}

      {selectedtype == "OCCUPATION" && (
        <>
          <div className="col-span-6 sm:col-span-6">
            <label
              htmlFor="nom_unite"
              className="block text-md font-bold leading-6 text-gray-900"
            >
              Nom unité *
            </label>
            <input
              type="text"
              name="nom_unite"
              id="nom_unite"
              placeholder="Saisir nom"
              className="  my-3 border border-gray-300 text-gray-900 font-semibold text-md rounded-lg focus:ring-gexpertise-100 focus:border-gexpertise-200 block w-full p-2.5 "
              {...register("nom_unite", {
                required: true,
              })}
            />
            {errors.nom_unite && (
              <span className="bg-red-100 text-red-800 text-md font-medium mr-2 mt-2 px-2.5 py-0.5 rounded ">
                champs obligatoire
              </span>
            )}
          </div>
          <div className="col-span-3 sm:col-span-3">
            <label
              htmlFor="surface_habitable"
              className="block text-md font-bold leading-6 text-gray-900"
            >
              Surface habitable
            </label>
            <input
              type="text"
              name="surface_habitable"
              id="surface_habitable"
              placeholder="Saisir surface habitable"
              className="  my-3 border border-gray-300 text-gray-900 font-semibold text-md rounded-lg focus:ring-gexpertise-100 focus:border-gexpertise-200 block w-full p-2.5 "
              {...register("surface_habitable")}
            />
          </div>

          <div className="col-span-3 sm:col-span-3">
            <label
              htmlFor="surface_plancher"
              className="block text-md font-bold leading-6 text-gray-900"
            >
              Surface de plancher
            </label>
            <input
              type="text"
              name="surface_plancher"
              id="surface_plancher"
              placeholder="Saisir surface de plancher"
              className="  my-3 border border-gray-300 text-gray-900 font-semibold text-md rounded-lg focus:ring-gexpertise-100 focus:border-gexpertise-200 block w-full p-2.5 "
              {...register("surface_plancher")}
            />
          </div>
        </>
      )}

      {(selectedtype == "ORGANISATION") && (
        <>
          <div className="col-span-6 sm:col-span-6">
            <label
              htmlFor="nom_unite"
              className="block text-md font-bold leading-6 text-gray-900"
            >
              Nom unité *
            </label>
            <input
              type="text"
              name="nom_unite"
              id="nom_unite"
              placeholder="Saisir nom"
              className="  my-3 border border-gray-300 text-gray-900 font-semibold text-md rounded-lg focus:ring-gexpertise-100 focus:border-gexpertise-200 block w-full p-2.5 "
              {...register("nom_unite", {
                required: true,
              })}
            />
            {errors.nom_unite && (
              <span className="bg-red-100 text-red-800 text-md font-medium mr-2 mt-2 px-2.5 py-0.5 rounded ">
                champs obligatoire
              </span>
            )}
          </div>
          <div className="col-span-6 sm:col-span-6">
            <label
              htmlFor="sous_type_unite"
              className="block text-md font-bold leading-6 text-gray-900"
            >
              Sous type unité
            </label>
            <input
              type="text"
              name="sous_type_unite"
              id="sous_type_unite"
              placeholder="Saisir sous type "
              className="  my-3 border border-gray-300 text-gray-900 font-semibold text-md rounded-lg focus:ring-gexpertise-100 focus:border-gexpertise-200 block w-full p-2.5 "
              {...register("sous_type_unite")}
            />
          </div>

          <div className="col-span-3 sm:col-span-3">
            <label
              htmlFor="surface_habitable"
              className="block text-md font-bold leading-6 text-gray-900"
            >
              Surface habitable
            </label>
            <input
              type="text"
              name="surface_habitable"
              id="surface_habitable"
              placeholder="Saisir surface habitable"
              className="  my-3 border border-gray-300 text-gray-900 font-semibold text-md rounded-lg focus:ring-gexpertise-100 focus:border-gexpertise-200 block w-full p-2.5 "
              {...register("surface_habitable")}
            />
          </div>

          <div className="col-span-3 sm:col-span-3">
            <label
              htmlFor="surface_plancher"
              className="block text-md font-bold leading-6 text-gray-900"
            >
              Surface de plancher
            </label>
            <input
              type="text"
              name="surface_plancher"
              id="surface_plancher"
              placeholder="Saisir surface de plancher"
              className="  my-3 border border-gray-300 text-gray-900 font-semibold text-md rounded-lg focus:ring-gexpertise-100 focus:border-gexpertise-200 block w-full p-2.5 "
              {...register("surface_plancher")}
            />
          </div>
        </>
      )}

{(selectedtype == "VOLUMETRIQUE" ) && (
        <>
          <div className="col-span-6 sm:col-span-6">
            <label
              htmlFor="nom_unite"
              className="block text-md font-bold leading-6 text-gray-900"
            >
              Nom unité *
            </label>
            <input
              type="text"
              name="nom_unite"
              id="nom_unite"
              placeholder="Saisir nom"
              className="  my-3 border border-gray-300 text-gray-900 font-semibold text-md rounded-lg focus:ring-gexpertise-100 focus:border-gexpertise-200 block w-full p-2.5 "
              {...register("nom_unite", {
                required: true,
              })}
            />
            {errors.nom_unite && (
              <span className="bg-red-100 text-red-800 text-md font-medium mr-2 mt-2 px-2.5 py-0.5 rounded ">
                champs obligatoire
              </span>
            )}
          </div>
         


          <div className="col-span-6 sm:col-span-6">
            <label
              htmlFor="Numéro_de_volume "
              className="block text-md font-bold leading-6 text-gray-900"
            >
              Numéro de volume *
            </label>
            <input
              type="text"
              name="Numéro_volume"
              id="numero_volume"
              placeholder="Saisir Numéro de volume  "
              className="  my-3 border border-gray-300 text-gray-900 font-semibold text-md rounded-lg focus:ring-gexpertise-100 focus:border-gexpertise-200 block w-full p-2.5 "
              {...register("numero_volume", {
                required: true,
              })}
            />
          </div>

        </>
      )}


    </>
  );
};

export default FormsAddUnite;
